/* eslint-disable @atlaskit/design-system/no-emotion-primitives */
/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { jsx } from '@emotion/react';

import { Box, xcss } from '@atlaskit/primitives';

import type { ColorTokenCategoryProps } from './color';

const borderStyles = xcss({
	borderStyle: 'solid',
	borderWidth: 'border.width',
	borderColor: 'color.border',
});

const tileStyles = xcss({
	width: '40px',
	height: '40px',
});

const spaceWidthStyles = xcss({
	width: 'size.600',
});

/**
 * UI for representing a radius token.
 */
export const Radius = ({ value }: ColorTokenCategoryProps): React.JSX.Element => (
	<Box paddingInline="space.050" xcss={spaceWidthStyles}>
		<Box
			padding="space.200"
			xcss={[borderStyles, (value as string).includes('%') && tileStyles]}
			style={{
				borderRadius: value,
			}}
		/>
	</Box>
);
